import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';

import { RouterModule } from '@angular/router';
import { RouteConstants } from '../../../../core/constants/routes';
import { SidenavBottomPanelInfoComponent } from '../sidenav-bottom-panel-info/sidenav-bottom-panel-info.component';

@Component({
    selector: 'app-sidenav-bottom-panel',
    templateUrl: './sidenav-bottom-panel.component.html',
    styleUrl: './sidenav-bottom-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, RouterModule, SidenavBottomPanelInfoComponent],
})
export class SidenavBottomPanelComponent {
    @Input() isCollapsed!: boolean;

    profileRoute = RouteConstants.Profile.getFullRoute('INDEX');
}
